var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "col-xs-12 p-20" }, [
        _c("div", { staticClass: "col-xs-12 p-0 flex-center" }, [
          _c("img", {
            staticClass: "left-arrow cursor-pointer",
            attrs: {
              src: "/static/images/icons/chevron_left.svg",
              alt: "chevronleft-icon",
            },
            on: { click: _vm.checkIsFormTouched },
          }),
          _c(
            "span",
            {
              staticClass: "pl-10 font-24 header cursor-pointer",
              on: { click: _vm.checkIsFormTouched },
            },
            [_vm._v(_vm._s(_vm.alertId ? "Update Alert" : "Create New Alert"))]
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 plr-25 mb-30" }, [
            _c(
              "ul",
              { staticClass: "crumb-trail" },
              _vm._l(_vm.slidesInfo, function (slide, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "col-xs-6 p-0",
                    class: {
                      "is-active-slide": _vm.currentSlider === index,
                      completed_slide: _vm.currentSlider > index,
                    },
                  },
                  [
                    _c("div", { staticClass: "crumb" }, [
                      _vm.currentSlider > index
                        ? _c("img", {
                            staticClass: "breadcrumb-img",
                            attrs: {
                              src: "/static/images/icons/circle_check.svg",
                              alt: "check-icon",
                            },
                          })
                        : _vm._e(),
                      _c("span", { staticClass: "ml-5" }, [
                        _vm._v(_vm._s(slide.title)),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentSlider === 0,
                expression: "currentSlider === 0",
              },
            ],
            staticClass: "col-xs-12 pl-20 pr-20 mb-30",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 p-0 font-18 mb-4 font-medium color-light-black",
              },
              [_vm._v(" Enter the details below to proceed: ")]
            ),
            _vm._m(0),
            _c(
              "div",
              { staticClass: "col-xs-12 p-0" },
              [
                _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
                  _vm._m(1),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 p-0" },
                    [
                      _c("vue-editor", {
                        staticClass: "custom-title",
                        attrs: { editorToolbar: _vm.customToolbar },
                        on: {
                          "text-change": function ($event) {
                            return _vm.removeStyles()
                          },
                        },
                        model: {
                          value: _vm.$v.alertFormDetails.title.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.alertFormDetails.title,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.alertFormDetails.title.$model",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6 pl-0 xs-pr-0" },
                    [
                      _vm._m(2),
                      _vm.regWatchCountriesList
                        ? _c(
                            "div",
                            { staticClass: "col-xs-12 p-0" },
                            [
                              _c(
                                "multiselect",
                                {
                                  staticClass: "multiselect-single-dropdown",
                                  class: !_vm.$v.alertFormDetails.countryName
                                    .$model
                                    ? "un-selected"
                                    : "",
                                  attrs: {
                                    showLabels: false,
                                    "close-on-select": true,
                                    "allow-empty": false,
                                    searchable: true,
                                    options: _vm.regWatchCountriesList.map(
                                      (regCountry) => regCountry.country_name
                                    ),
                                    placeholder: "Select country",
                                  },
                                  model: {
                                    value:
                                      _vm.$v.alertFormDetails.countryName
                                        .$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.alertFormDetails.countryName,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.alertFormDetails.countryName.$model",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "noResult" },
                                      slot: "noResult",
                                    },
                                    [_vm._v("No matching data")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c("div", { staticClass: "col-xs-6 col-sm-3 pr-0 xs-pl-0" }, [
                    _c("label", { staticClass: "font-14 form-group" }, [
                      _vm._v("Effective Date"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 p-0 effective_date_picker" },
                      [
                        _c("date-picker", {
                          attrs: {
                            editable: false,
                            valueType: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
                            placeholder: "DD/MM/YYYY",
                            format: "DD/MM/YYYY",
                          },
                          on: { change: _vm.checkisPreviousDate },
                          model: {
                            value:
                              _vm.$v.alertFormDetails.regulatoryEffectiveDate
                                .$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.alertFormDetails.regulatoryEffectiveDate,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.alertFormDetails.regulatoryEffectiveDate.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
                  _vm._m(3),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 p-0 edit-profile-section" },
                    [
                      _c("vue-html5-editor", {
                        attrs: {
                          ondrag: "return false",
                          ondrop: "return false",
                          autocomplete: "off",
                          id: "Answer",
                          height: 145,
                          "auto-height": false,
                          content: _vm.alertFormDetails.description,
                        },
                        on: { change: _vm.updateDescription },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._l(_vm.linkList, function (linkItem, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "col-xs-12 p-0 mb-20" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-6 pl-0 xs-pr-0 xs-mb-15",
                        },
                        [
                          _c("label", { staticClass: "font-14 form-group" }, [
                            _vm._v("Add link"),
                          ]),
                          _c("div", { staticClass: "col-xs-12 p-0" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: linkItem["link"],
                                  expression: "linkItem['link']",
                                },
                              ],
                              staticClass: "form-control",
                              class:
                                linkItem["invalid"] && !!linkItem["link"].length
                                  ? "error_msg_display"
                                  : "",
                              attrs: { type: "text", placeholder: "http://" },
                              domProps: { value: linkItem["link"] },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      linkItem,
                                      "link",
                                      $event.target.value
                                    )
                                  },
                                  function ($event) {
                                    return _vm.validateUrl(linkItem)
                                  },
                                ],
                                paste: function ($event) {
                                  return _vm.onPaste($event, index)
                                },
                              },
                            }),
                            linkItem["invalid"] && !!linkItem["link"].length
                              ? _c("div", { staticClass: "danger" }, [
                                  _vm._v(" Please enter valid url "),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "col-xs-8 col-sm-4 xs-pl-0" }, [
                        _c("label", { staticClass: "font-14 form-group" }, [
                          _vm._v("Link label"),
                        ]),
                        _c("div", { staticClass: "col-xs-12 p-0" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: linkItem["label"],
                                expression: "linkItem['label']",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Link label",
                              disabled: linkItem.label_disabled,
                            },
                            domProps: { value: linkItem["label"] },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(linkItem, "label", $event.target.value)
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-xs-4 col-sm-2 pr-0" }, [
                        _c("div", { staticClass: "col-xs-12 p-0 mt-25" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "no-wrap emergo-white-button w-100 add-remove-btn",
                              attrs: { id: "addLink", "data-toggle": "tab" },
                              on: {
                                click: function ($event) {
                                  return _vm.addOrRemoveLink(index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.linkList.length - 1 > index
                                      ? "Remove"
                                      : "Add"
                                  )
                              ),
                              _c("span", { staticClass: "sm-hidden" }, [
                                _vm._v(" Link"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ]
        ),
        _vm.currentSlider === 1
          ? _c(
              "div",
              { staticClass: "col-xs-12 pl-20 pr-20" },
              [
                _c("preview-alert-form", {
                  attrs: { alertDetails: _vm.alertFormDetails },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "col-xs-12 pl-20 pr-20" }, [
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 pl-0 pr-0 pt-20 footer-wrapper flex-between",
            },
            [
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "mb-10 emergo-white-button sm-mr-15 plr-30",
                    class: { opacity: _vm.currentSlider === 0 },
                    attrs: { disabled: !_vm.currentSlider },
                    on: { click: _vm.changeSlider },
                  },
                  [_vm._v(" Back ")]
                ),
                !_vm.alertRecordDetails ||
                (_vm.alertRecordDetails &&
                  _vm.alertRecordDetails.Status !== "Published")
                  ? _c(
                      "button",
                      {
                        staticClass: "mb-10 emergo-green-button xs-ml-15",
                        class: { opacity: _vm.isDisabled },
                        attrs: { disabled: _vm.isDisabled },
                        on: {
                          click: function ($event) {
                            return _vm.submitDetails(true)
                          },
                        },
                      },
                      [_vm._v(" Save For Later ")]
                    )
                  : _vm._e(),
              ]),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "sm-mr-15 mb-10 emergo-white-button plr-22",
                    on: { click: _vm.checkIsFormTouched },
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "mb-10 emergo-green-button xs-ml-15 plr-55",
                    class: { opacity: _vm.isDisabled },
                    attrs: { disabled: _vm.isDisabled },
                    on: {
                      click: function ($event) {
                        return _vm.submitDetails()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.currentSlider === 0 ? "Next" : "Submit") +
                        " "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
      _c("confirmation-modal", {
        attrs: { confirmationMessage: _vm.confirmationMessage },
        on: { discardChanges: _vm.hideConfirmPopup },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-xs-12 p-0 color-light-black font-14 mb-30" },
      [
        _vm._v(" Mandatory fields are marked with “ "),
        _c("span", { staticClass: "danger" }, [_vm._v("*")]),
        _vm._v(" ” symbol "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "font-14 form-group" }, [
      _vm._v("Title "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "font-14 form-group" }, [
      _vm._v("Country "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "font-14 form-group" }, [
      _vm._v("Description "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }